import { useEffect } from "react";

import { ACTIVE_JOB_POLL_MS } from "./provider-site";

// While the agent works on a message the page re-reads the site, as the app does.
export function useJobPolling(
  isWorking: boolean,
  startPolling: (interval: number) => void,
  stopPolling: () => void
) {
  useEffect(() => {
    if (isWorking) {
      startPolling(ACTIVE_JOB_POLL_MS);
    } else {
      stopPolling();
    }
    return stopPolling;
  }, [isWorking, startPolling, stopPolling]);
}
